const colorChart = ["#BA071C", "#E76219", "#005BA7", "#FFE90A", "#5EAE3B"];

const dummyChartData = [
  [8750000, 5150000, 9300000, 1100000, 4700000, 8300000, 7000000],
  [5300000, 6675000, 8900000, 1050000, 7005000, 3110000, 8900000],
];

export { colorChart, dummyChartData };
